import { render } from "./Mario.vue?vue&type=template&id=7fae5d20"
import script from "./Mario.vue?vue&type=script&lang=js"
export * from "./Mario.vue?vue&type=script&lang=js"

import "./Mario.vue?vue&type=style&index=0&id=7fae5d20&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__